import {
	FETCH_CLIENT,
	FETCH_USERS,
	FETCH_USER,
	FETCH_CONDITIONS_SURVEYS,
	FETCH_ORGANIZATION,
	FETCH_CLIENT_ORGANIZATION,
	FETCH_ORGANIZATIONS,
  FETCH_USER_INVITATIONS
} from '../actions/types';

const initialState = {
	client: {},
	users: [],
	user: [],
	conditions_surveys: [],
	organization: [],
	clients_org: [],
	organizations: [],
  user_invitations: []
};

export default function (state = initialState, action) {
	switch (action.type) {
		case FETCH_CLIENT:
			return {
				...state,
				client: action.payload,
			};
		case FETCH_USERS:
			return {
				...state,
				users: action.payload,
			};
		case FETCH_USER:
			return {
				...state,
				user: action.payload,
			};
		case FETCH_CONDITIONS_SURVEYS:
			return {
				...state,
				conditions_surveys: action.payload,
			};
		case FETCH_ORGANIZATION:
			return {
				...state,
				organization: action.payload,
			};
		case FETCH_CLIENT_ORGANIZATION:
			return {
				...state,
				clients_org: action.payload,
			};
		case FETCH_ORGANIZATIONS:
			return {
				...state,
				organizations: action.payload,
			};
    case FETCH_USER_INVITATIONS:
			return {
				...state,
				user_invitations: action.payload,
			};
		default:
			return state;
	}
}
